
import { Edit, SimpleForm, TextInput, DateInput, NumberInput } from 'react-admin';

export const Tbl_goalEdit = props => (
    <Edit {...props}>
        <SimpleForm>
            <NumberInput source="id" disabled />
            <NumberInput source="partitaId"  />
            <NumberInput source="playerId"  />
            <NumberInput source="minuto"  />
            <TextInput source="note"  />
            <NumberInput source="flVisibile"  />
            <NumberInput source="flAttivo"  />
            <NumberInput source="flAnnullato"  />
            <NumberInput source="ordinamento"  />
            <DateInput source="createdAt"  />
            <DateInput source="updatedAt"  />
        </SimpleForm>
    </Edit>
);
            